import { PatientOnboarding } from '@aldebaran/common/types/variant';

/**
 * Returns true when the onboarding flow is configured as a waiting-room
 * kiosk ("borne").
 */
export const isKioskOnboarding = (
  patientOnboarding: PatientOnboarding | null | undefined,
): boolean => patientOnboarding === 'BORNE';

/** Dispatched on `window` just before the kiosk resets an idle session. */
export const KIOSK_INACTIVITY_RESET_EVENT = 'kiosk-inactivity-reset';
